import { pathOfUrl } from './workplace.config';

/**
 * Which page of the editor of orders an address is — for the rule «an order is open» of `CallStateService`. Pure.
 *  - `/order/new` — step 1, the choice: nothing is held, the draft stays; it holds no order;
 *  - `/order/new/:cartId` — step 2, a reservation of the operator is held;
 *  - `/order/:id/edit` — the change of an order.
 */
export type EditorRoute =
  | { readonly kind: 'choice' }
  | { readonly kind: 'cart'; readonly cartId: number }
  | { readonly kind: 'edit'; readonly orderId: number };

export function editorRouteOf(url: string | undefined | null): EditorRoute | undefined {
  const path = pathOfUrl(url);
  if (path === '/order/new') {
    return { kind: 'choice' };
  }
  const cart = /^\/order\/new\/(\d+)$/.exec(path);
  if (cart) {
    return { kind: 'cart', cartId: Number(cart[1]) };
  }
  const edit = /^\/order\/(\d+)\/edit$/.exec(path);
  if (edit) {
    return { kind: 'edit', orderId: Number(edit[1]) };
  }
  return undefined;
}
